export default __webpack_public_path__ + "static/media/rocket-chat.47618030.svg";